import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import POSStatistics from './POSDashboard/posStatistics';

const SelectOption = () => {
  const navigate = useNavigate();
  const [thirdpartyhtmls, setThirdpartyhtmls] = useState([]);
  const [viewMode, setViewMode] = useState('selection'); // 'selection' | 'iframe' | 'report'
  const [activeThirdParty, setActiveThirdParty] = useState({ name: '', url: '' });
  const [isFullscreen, setIsFullscreen] = useState(false);

  useEffect(() => {
    try {
      const savedHtmls = localStorage.getItem('thirdpartyhtmls');
      if (savedHtmls) {
        const parsed = JSON.parse(savedHtmls);
        if (Array.isArray(parsed)) {
          setThirdpartyhtmls(parsed);
        }
      }
    } catch (e) {
      console.error('Error parsing thirdpartyhtmls from localStorage:', e);
    }

    const handleFullscreenChange = () => {
      setIsFullscreen(!!document.fullscreenElement);
    };
    document.addEventListener('fullscreenchange', handleFullscreenChange);
    return () => {
      document.removeEventListener('fullscreenchange', handleFullscreenChange);
    };
  }, []);

  const toggleFullscreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen().catch((err) => {
        console.error('Error attempting to enable full-screen mode:', err);
      });
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      }
    }
  };

  const handleOpenMerchantPanel = () => {
    navigate('/');
  };

  const handleOpenThirdParty = (item) => {
    if (item && item.url) {
      window.open(item.url, '_blank');
    }
  };

  const handleOpenReport = () => {
    navigate('/third-party-report');
  };

  // Render Full Screen Iframe View
  if (viewMode === 'iframe') {
    return (
      <div 
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          backgroundColor: '#343a40',
          zIndex: 999999,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <nav className="navbar navbar-expand navbar-light navbar-white bg-white m-0 px-3 border-bottom shadow-sm" style={{ height: '50px' }}>
          <span className="navbar-brand font-weight-bold text-dark d-flex align-items-center" style={{ fontSize: '16px' }}>
            <i className="fas fa-globe text-info mr-2"></i>
            {activeThirdParty.name || 'Third Party Page'}
          </span>

          <ul className="navbar-nav ml-auto d-flex align-items-center">
            <li className="nav-item mr-2">
              <button className="btn btn-primary btn-sm" onClick={handleOpenMerchantPanel}>
                <i className="fas fa-store mr-1"></i>
                Merchant Panel
              </button>
            </li>
            <li className="nav-item">
              <button className="btn btn-secondary btn-sm" onClick={() => setViewMode('selection')}>
                <i className="fas fa-times mr-1"></i>
                Back to Options
              </button>
            </li>
          </ul>
        </nav>
        <iframe
          src={activeThirdParty.url}
          title={activeThirdParty.name || 'Third Party HTML'}
          style={{
            width: '100%',
            height: 'calc(100vh - 50px)',
            border: 'none',
          }}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
        />
      </div>
    );
  }

  // Render Full Screen Report View
  if (viewMode === 'report') {
    return (
      <div 
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          backgroundColor: '#f4f6f9',
          zIndex: 999999,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <nav className="navbar navbar-expand navbar-dark bg-dark m-0 px-3" style={{ height: '50px', borderBottom: '1px solid #4b545c' }}>
          <span className="navbar-brand font-weight-bold text-white d-flex align-items-center" style={{ fontSize: '16px' }}>
            <i className="fas fa-chart-bar text-success mr-2"></i>
            Report Dashboard
          </span>

          <ul className="navbar-nav ml-auto d-flex align-items-center">
            <li className="nav-item mr-2">
              <button className="btn btn-outline-light btn-sm" onClick={toggleFullscreen}>
                <i className={isFullscreen ? "fas fa-compress mr-1" : "fas fa-expand mr-1"}></i>
                {isFullscreen ? "Exit Fullscreen" : "Fullscreen"}
              </button>
            </li>
            <li className="nav-item mr-2">
              <button className="btn btn-primary btn-sm" onClick={handleOpenMerchantPanel}>
                <i className="fas fa-store mr-1"></i>
                Merchant Panel
              </button>
            </li>
            <li className="nav-item">
              <button className="btn btn-danger btn-sm" onClick={() => setViewMode('selection')}>
                <i className="fas fa-times mr-1"></i>
                Back to Options
              </button>
            </li>
          </ul>
        </nav>
        <div style={{ width: '100%', height: 'calc(100vh - 50px)', overflowY: 'auto' }}>
          <POSStatistics />
        </div>
      </div>
    );
  }

  // Standard 3 Buttons Only View (Centered Full Screen)
  const listItems = thirdpartyhtmls.length > 0 
    ? thirdpartyhtmls 
    : [{ name: 'test', url: '/retail-pulse-report' }];

  return (
    <div 
      style={{
        minHeight: '100vh',
        width: '100vw',
        backgroundColor: '#f4f6f9',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px',
        boxSizing: 'border-box'
      }}
    >
      <div className="container" style={{ maxWidth: '1100px' }}>
        <div className="row justify-content-center align-items-center">
          {/* Option 1: Merchant Panel */}
          <div className="col-lg-4 col-md-6 col-12 mb-4">
            <div 
              className="small-box bg-info" 
              style={{ 
                cursor: 'pointer', 
                borderRadius: '10px', 
                overflow: 'hidden', 
                boxShadow: '0 6px 15px rgba(0,0,0,0.15)',
                transition: 'transform 0.2s ease-in-out'
              }}
              onClick={handleOpenMerchantPanel}
            >
              <div className="inner p-4">
                <h3 style={{ fontSize: '28px', fontWeight: 'bold', marginBottom: '10px' }}>Merchant Panel</h3>
                <p style={{ fontSize: '14px', marginBottom: '0', opacity: 0.9 }}>
                  Access merchant management, device configuration, campaigns, and audio settings.
                </p>
              </div>
              <div className="icon" style={{ right: '15px', top: '15px' }}>
                <i className="fas fa-store" />
              </div>
              <a 
                href="#" 
                className="small-box-footer py-3" 
                onClick={(e) => { e.preventDefault(); handleOpenMerchantPanel(); }}
                style={{ fontSize: '15px', fontWeight: '600' }}
              >
                Open Merchant Panel <i className="fas fa-arrow-circle-right ml-1"></i>
              </a>
            </div>
          </div>

          {/* Option 2: Dynamic Third Party Buttons (e.g. "test") */}
          {listItems.map((item, index) => (
            <div className="col-lg-4 col-md-6 col-12 mb-4" key={index}>
              <div 
                className="small-box" 
                style={{ 
                  cursor: 'pointer', 
                  borderRadius: '10px', 
                  overflow: 'hidden', 
                  boxShadow: '0 6px 15px rgba(0,0,0,0.15)',
                  backgroundColor: '#ffc107',
                  color: '#1f2d3d',
                  transition: 'transform 0.2s ease-in-out'
                }}
                onClick={() => handleOpenThirdParty(item)}
              >
                <div className="inner p-4">
                  <h3 style={{ fontSize: '28px', fontWeight: 'bold', marginBottom: '10px', color: '#1f2d3d' }}>{item.name}</h3>
                  <p style={{ fontSize: '14px', marginBottom: '0', wordBreak: 'break-all', opacity: 0.9, color: '#1f2d3d' }}>
                    {item.url || 'Launch third-party portal in full screen view.'}
                  </p>
                </div>
                <div className="icon" style={{ right: '15px', top: '15px' }}>
                  <i className="fas fa-external-link-alt" style={{ color: 'rgba(0,0,0,0.15)' }} />
                </div>
                <a 
                  href="#" 
                  className="small-box-footer py-3" 
                  onClick={(e) => { e.preventDefault(); handleOpenThirdParty(item); }}
                  style={{ fontSize: '15px', fontWeight: '600', color: '#1f2d3d', backgroundColor: 'rgba(0,0,0,0.1)' }}
                >
                  Open {item.name} <i className="fas fa-arrow-circle-right ml-1"></i>
                </a>
              </div>
            </div>
          ))}

          {/* Option 3: Report Button */}
          <div className="col-lg-4 col-md-6 col-12 mb-4">
            <div 
              className="small-box bg-success" 
              style={{ 
                cursor: 'pointer', 
                borderRadius: '10px', 
                overflow: 'hidden', 
                boxShadow: '0 6px 15px rgba(0,0,0,0.15)',
                transition: 'transform 0.2s ease-in-out'
              }}
              onClick={handleOpenReport}
            >
              <div className="inner p-4">
                <h3 style={{ fontSize: '28px', fontWeight: 'bold', marginBottom: '10px' }}>Report</h3>
                <p style={{ fontSize: '14px', marginBottom: '0', opacity: 0.9 }}>
                  View full screen analytics, POS statistics, and detailed system reports.
                </p>
              </div>
              <div className="icon" style={{ right: '15px', top: '15px' }}>
                <i className="fas fa-chart-line" />
              </div>
              <a 
                href="#" 
                className="small-box-footer py-3" 
                onClick={(e) => { e.preventDefault(); handleOpenReport(); }}
                style={{ fontSize: '15px', fontWeight: '600' }}
              >
                Open Report <i className="fas fa-arrow-circle-right ml-1"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelectOption;
